export default {
      id: "detailed-questions-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "sprite.svg#detailed-questions",
      toString: function () {
        return this.url;
      }
    }